import { Route, Routes } from 'react-router-dom';

import { IntelligenceRemoteView } from './views/remote/intelligenceRemote.view';

export const IntelligenceView = (): JSX.Element => {
  return (
    <Routes>
      <Route path="*" element={<IntelligenceRemoteView />} />
    </Routes>
  );
};
